import { parse } from 'querystring';
import { useApolloClient, ApolloClient } from '@apollo/client';
import { NormalizedCacheObject } from '@apollo/client/cache';
import { GetExperimentsQuery, Experiment } from '@catalogo/core-types';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { dispatchEvent } from '@catalogo/core-metrics';
import { getCookies } from './cookies';
import getExperiments from './query.graphql';

export const getTestABList = (client: ApolloClient<NormalizedCacheObject>): Experiment[] | undefined => {
  const cookies = getCookies(client);

  const data = client.readQuery<GetExperimentsQuery>({
    query: getExperiments,
    variables: {
      pid: cookies?.['B2W-PID'],
    },
  });

  const experiments = data?.experiments as Experiment[];
  return experiments || [];
};

interface GetTestAB {
  name: string;
  client: ApolloClient<NormalizedCacheObject>;
  location: Location;
}

interface Location {
  search: string;
}

export const getTestAB = ({ name, client, location }: GetTestAB): string | undefined => {
  const { search } = location;
  const parsedQs = parse(search ? search.replace('?', '') : '');
  const override = parsedQs?.[name];
  const experiments = getTestABList(client);

  return override?.toString() || experiments?.find(e => e?.name === name)?.choice;
};

export const useTestAB = (name: string, override?: string): string | undefined => {
  const client = useApolloClient() as ApolloClient<NormalizedCacheObject>;
  const location = useLocation();
  const resultTest = getTestAB({ name, client, location });

  useEffect(() => {
    const variant = override || resultTest;
    if (variant) {
      dispatchEvent('experiment:exposure', { experiment: { experimentId: name, variant: override || resultTest } });
    }
  }, []);

  return override || resultTest;
};
